import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "title-row" }

import { computed, onMounted, ref } from "vue";
import { groupBy } from "lodash";
import { DateTime } from "luxon";
import { TANDEM_DATE_SHORT } from "@/core";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import TimelineAuditLogEvent from "@/components/TimelineAuditLogEvent.vue";
import TimelineEvent from "@/components/TimelineEvent.vue";
import {
  getAuditLog,
  AuditLogEvent,
  AuditLog,
} from "@/services/auditLogService";

export interface Props {
  cohortId: string;
  memberId: string;
}

interface DayEvents {
  date: DateTime;
  events: AuditLogEvent[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentAuditLog',
  props: {
    cohortId: {},
    memberId: {}
  },
  setup(__props: any) {

const props = __props;



const auditLog = ref<AuditLog>();

onMounted(async () => {
  auditLog.value = await getAuditLog(props.cohortId, props.memberId);
});

const compareDayEvents = (a: DayEvents, b: DayEvents): number =>
  b.date.toMillis() - a.date.toMillis();
const compareLogEvents = (a: AuditLogEvent, b: AuditLogEvent): number =>
  b.timestamp.toMillis() - a.timestamp.toMillis();

const days = computed<DayEvents[]>(() => {
  const events = auditLog.value?.events || [];
  const eventsByDay = groupBy(events, (event) =>
    event.timestamp.startOf("day")
  );
  return Object.entries(eventsByDay)
    .map(([timestamp, events]) => ({
      date: DateTime.fromISO(timestamp),
      events: events.toSorted(compareLogEvents),
    }))
    .toSorted(compareDayEvents);
});

return (_ctx: any,_cache: any) => {
  return (!auditLog.value)
    ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", null, [
            _createTextVNode(" All Activity | "),
            _createElementVNode("span", null, _toDisplayString(auditLog.value.name), 1),
            _createTextVNode(),
            _createElementVNode("span", null, "(" + _toDisplayString(auditLog.value.username) + ")", 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: day.date.toISO()
          }, [
            _createVNode(TimelineEvent, {
              label: `${ day.date.toFormat(_unref(TANDEM_DATE_SHORT)) }`
            }, null, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.events, (event, index) => {
              return (_openBlock(), _createBlock(TimelineAuditLogEvent, {
                key: index,
                event: event
              }, null, 8, ["event"]))
            }), 128))
          ], 64))
        }), 128))
      ], 64))
}
}

})